import * as React from "react";

import {
  PRESENTATION_SCROLL_ACTIONS,
  usePresenterForScroll,
} from "../../providers/presenter-for-scroll-provider";

interface UseScrollToTopProps {
  selector?: string;
}
export const useScrollToTop = (props: UseScrollToTopProps = {}): void => {
  const { scrollActionToTake, onScrollAnimationBegin } =
    usePresenterForScroll();

  const handleScroll = React.useCallback(() => {
    if (scrollActionToTake === PRESENTATION_SCROLL_ACTIONS.SCROLL_TO_TOP) {
      let element: { scrollTo: typeof window["scrollTo"] } | null = window;
      if (props.selector) {
        element = document.querySelector(props.selector);
      }
      element?.scrollTo({ top: 0, behavior: "smooth" });
      onScrollAnimationBegin();
    }
  }, [scrollActionToTake, onScrollAnimationBegin, props.selector]);

  React.useEffect(() => {
    window.addEventListener(UseScrollToTopEventKey, handleScroll);

    return () => {
      window.removeEventListener(UseScrollToTopEventKey, handleScroll);
    };
  }, [handleScroll]);

  React.useEffect(() => {
    if (scrollActionToTake) {
      window.dispatchEvent(new Event(UseScrollToTopEventKey));
    }
  }, [scrollActionToTake]);
};

const UseScrollToTopEventKey = "bbnt-use-scroll-to-top";
